import { render, staticRenderFns } from "./enTouchDetail.vue?vue&type=template&id=94fe97fe&scoped=true"
import script from "./enTouchDetail.vue?vue&type=script&lang=js"
export * from "./enTouchDetail.vue?vue&type=script&lang=js"
import style0 from "./enTouchDetail.vue?vue&type=style&index=0&id=94fe97fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94fe97fe",
  null
  
)

export default component.exports